import { experienceBuilderApi } from 'api'

export const fetchOUs = (section: string) =>
  experienceBuilderApi.get<{ data: any[] }>('/marketing-capabilities/ous', {
    params: {
      section,
    },
  })
